import "./QuizExamPlaceholders.scss";
function QuizExamPlaceholders(props) {
  return (
    <div className="practice-exam-container-placeholders">
      <div className="practice-exam-option">
        <div className="practice-exam-container">
          <div className="practice-exam-top">
            <div className="practice-exam-top-left">
              <div className="title"></div>
              <div className="sub-title"></div>
            </div>
          </div>
          <div className="practice-exam-center">
            <div className="practice-exam-center-left">
              <div className="title"></div>
              <div className="questions-container">
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
                <div className="question"></div>
              </div>
            </div>
            <div className="practice-exam-center-right">
              <div className="practice-exam-center-right-top">
                <div className="sub-title"></div>
                <div className="title-container">
                  <div className="title"></div>
                </div>
              </div>
              <div className="practice-exam-center-right-bottom">
                <div>
                  <div className="answer-cont"></div>
                  <div className="answer-cont"></div>
                  <div className="answer-cont"></div>
                  <div className="answer-cont"></div>
                </div>

                <div className="btn-container">
                  <button className="prev-btn"></button>
                  <button className="next-btn"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuizExamPlaceholders;
